/* eslint-disable @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call,  @typescript-eslint/no-unsafe-assignment */
/* eslint-disable import/no-extraneous-dependencies, @typescript-eslint/no-var-requires, spaced-comment, prefer-template, no-else-return, @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-inferrable-types, react-hooks/rules-of-hooks, @typescript-eslint/restrict-plus-operands, no-useless-concat, arrow-body-style */

import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import i18n from "./i18n";
import { Timezone, TimezoneMapping } from "../reducers/profile/actions";

export function isToday(date: Date): boolean {
    return dayjs(date).isToday();
}

export const weekDays = [
    {
        short: "mon",
        narrow: "m",
        value: 1,
    },
    {
        short: "tue",
        narrow: "t",
        value: 2,
    },
    {
        short: "wed",
        narrow: "w",
        value: 3,
    },
    {
        short: "thu",
        narrow: "t",
        value: 4,
    },
    {
        short: "fri",
        narrow: "f",
        value: 5,
    },
    {
        short: "sat",
        narrow: "s",
        value: 6,
    },
    {
        short: "sun",
        narrow: "s",
        value: 7,
    },
];

export const numberToWeekDay: {
    [id: number]: { long: string; short: string; narrow: string };
} = {
    1: { long: "monday", short: "mon", narrow: "m" },
    2: { long: "tuesday", short: "tue", narrow: "t" },
    3: { long: "wednesday", short: "wed", narrow: "w" },
    4: { long: "thursday", short: "thu", narrow: "t" },
    5: { long: "friday", short: "fri", narrow: "f" },
    6: { long: "saturday", short: "sat", narrow: "s" },
    7: { long: "sunday", short: "sun", narrow: "s" },
};

const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
export function getMonthName(date: Date, _locale: string = "en-us"): string {
    return monthNames[date.getMonth()];
}

export function prettyDate(date: Date | dayjs.Dayjs): string {
    const d = dayjs(date);
    const { t } = useTranslation();
    return isToday(d.locale(i18n.language).toDate())
        ? `${t("Today")} ${d.locale(i18n.language).format("MMMM DD")}`
        : d.format("YYYY, MMMM DD");
    /*const dayStr = `${ getMonthName(date) } ${date.getDate()}`;
    if (isToday(date)) {
        return `Today, ${ dayStr }`;
    }

    return `${ date.getFullYear() }, ${ dayStr }`;*/
}

export function apiDate(date: Date): string {
    return dayjs(date).format("YYYY-MM-DD");
}
export function apiDatenew(date: Date): string {
    return dayjs(date).format("MMM DD");
}

export function getTimeInAmPmFormat(date: string) {
    const hours_mm = date.slice(19, 21);
    const hours_hh = date.slice(16, 18);
    const hours = Number(hours_hh);
    const suffix = hours >= 12 ? "Pm" : "Am";

    if (hours > 12) {
        return hours - 12 + ":" + hours_mm + " " + suffix;
    } else return hours + ":" + hours_mm + "" + " " + suffix;

    // return format(new Date(date), 'hh:mm a')
}

export const duratiionToMinutes = (duration: number): string => {
    const seconds = Math.floor((duration / 1000) % 60);
    const minutes = Math.floor((duration / (1000 * 60)) % 60);
    const min = minutes > 9 ? minutes : `0${minutes}`;
    const sec = seconds > 9 ? seconds : `0${seconds}`;
    return `${min}:${sec}`;
};

export const formatDate = (
    date: Date | string | undefined,
    format: string = "MM/DD/YYYY h:mm a",
    timezone?: string
) => {
    if (timezone) {
        return date
            ? dayjs(date)
                  .tz(TimezoneMapping[timezone as Timezone])
                  .format(format)
            : undefined;
    }
    return date ? dayjs(date).format(format) : undefined;
};

export const addTimeToDate = (date: Date, time: string) => {
    const [hour, minutes] = time
        .split(":")
        .map((item: string) => parseInt(item.trim(), 10));
    return new Date(date.setHours(hour, minutes));
};

export const secondsToHms = (time: number): string => {
    try {
        return new Date(time * 1000).toISOString().substring(14, 19);
    } catch (_) {
        return "00:00";
    }
};

export const dateDiff = (
    start: Date,
    end: Date,
    unit: "s" | "m" | "h" | "ms" = "s"
): number => {
    try {
        const startDate = dayjs(start);
        const endDate = dayjs(end);
        return endDate.diff(startDate, unit);
    } catch (_) {
        return 0;
    }
};
